import React from 'react'
import Navbar from '../components/common/Navbar'
import Getintouch from '../components/layout/GetInTouch'
import Footer from '../components/common/Footer'

function Operational_teams() {
    return (
        <>
            <Navbar />
            <Getintouch />
            <Footer />
        </>
    )
}

export default Operational_teams